import jsPDF from 'jspdf';

async function getImageFromUrl(url) {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export async function exportToPDF(infracciones, selectedIds) {
    const doc = new jsPDF();
    const seleccionadas = infracciones.filter(i => selectedIds.includes(i.id));
    const logoBase64 = await getImageFromUrl('/img/iconn.png');


    seleccionadas.forEach((i, index) => {
        if (index !== 0) doc.addPage();

        let y = 20;
        doc.setFontSize(10);

        doc.addImage(logoBase64, 'PNG', 160, y - 15, 30, 30);

        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        doc.text(`INFRACCIÓN #${i.id}`, 10, y);
        y += 8;

        doc.setFontSize(11);
        doc.setFont(undefined, 'bold');
        doc.text('DATOS DEL AGENTE', 10, y);
        y += 6;

        doc.setFont(undefined, 'normal');
        doc.text(`Agente: ${i.agente}`, 10, y);
        doc.text(`Serie del Equipo: ${i.serie_equipo}`, 110, y);
        y += 6;

        doc.setFont(undefined, 'bold');
        doc.text('DATOS DE LA INFRACCIÓN', 10, y);
        y += 6;

        doc.setFont(undefined, 'normal');
        doc.text(`Motivo: ${i.motivo}`, 10, y);
        y += 6;

        const ausente = i.conductor_ausente ? 'Sí' : 'No';
        doc.setFont(undefined, 'bold');
        doc.text('Conductor Ausente:', 10, y);
        doc.setFont(undefined, 'normal');
        doc.text(ausente, 55, y);
        y += 6;

        doc.text("Documentos Retenidos: " + (i.se_retuvo || 'N/A'), 10, y);

        let articulosTexto = i.articulos;
        if (typeof articulosTexto === "string") {
            try {
                const parsed = JSON.parse(articulosTexto);
                if (Array.isArray(parsed)) {
                    articulosTexto = parsed.join("\n");
                }
            } catch (e) {}
        } else if (Array.isArray(articulosTexto)) {
            articulosTexto = articulosTexto.join("\n");
        }

        y += doc.splitTextToSize(
            "Artículos Relacionados:\n" + (articulosTexto || 'N/A'),
            90 // ancho máximo
        ).reduce((acc, line) => {
            doc.text(line, 110, y + acc);
            return acc + 6; // 6 = altura de línea
        }, 0);

        doc.text(`Fecha: ${i.fecha || 'N/A'}`, 10, y);
        doc.text(`UMAs: ${i.cantidadUMAs || 'N/A'}`, 110, y);
        y += 8;

        doc.setFont(undefined, 'bold');
        doc.text('LUGAR DE LA INFRACCIÓN', 10, y);
        y += 6;

        doc.setFont(undefined, 'normal');
        doc.text(`Calle: ${i.calle || ''} entre ${i.entre_calle || ''} y ${i.y_calle || ''}`, 10, y);
        y += 6;
        doc.text(`Colonia: ${i.colonia || ''} - Municipio: ${i.municipio || ''}`, 10, y);
        y += 8;

        doc.setFont(undefined, 'bold');
        doc.text('DATOS DEL CONDUCTOR', 10, y);
        y += 6;

        doc.setFont(undefined, 'normal');
        const nombreCompleto = `${i.infractor_nombre || ''} ${i.infractor_apellido_paterno || ''} ${i.infractor_apellido_materno || ''}`;
        doc.text(`Nombre: ${nombreCompleto}`, 10, y);
        doc.text(`RFC: ${i.infractor_rfc || ''}`, 110, y);
        y += 6;
        doc.text(`Licencia: ${i.infractor_licencia || ''}`, 10, y);
        doc.text(`Tipo: ${i.infractor_tipo_licencia || ''}`, 110, y);
        y += 6;
        doc.text(`Fecha Emisión: ${i.infractor_emision || ''} - Vigencia: ${i.vigencia || ''}`, 10, y);
        y += 8;

        doc.setFont(undefined, 'bold');
        doc.text('DOMICILIO DEL CONDUCTOR', 10, y);
        y += 6;

        doc.setFont(undefined, 'normal');
        doc.text(`Calle: ${i.infractor_calle || ''} #${i.infractor_num_exterior || ''} Int: ${i.infractor_num_interior || ''}`, 10, y);
        y += 6;
        doc.text(`Colonia: ${i.infractor_colonia || ''} - CP: ${i.infractor_codigo_postal || ''}`, 10, y);
        y += 6;
        doc.text(`Municipio: ${i.infractor_municipio || ''} - Estado: ${i.infractor_estado || ''}`, 10, y);
        y += 8;

        doc.setFont(undefined, 'bold');
        doc.text('DATOS DEL VEHÍCULO', 10, y);
        y += 6;

        doc.setFont(undefined, 'normal');
        doc.text(`Marca/Submarca: ${i.vehiculo_marca || ''} ${i.vehiculo_submarca || ''}`, 10, y);
        doc.text(`Placas: ${i.vehiculo_placas || ''}`, 110, y);
        y += 6;
        doc.text(`Color: ${i.vehiculo_color || ''} - Modelo: ${i.vehiculo_modelo || ''}`, 10, y);
        y += 6;
        doc.text(`Tarjeta Circulación: ${i.vehiculo_tarjeta_circulacion || ''}`, 10, y);
        y += 6;
        doc.text(`Serie: ${i.vehiculo_serie_auto || ''} - Inventario: ${i.vehiculo_folio_inventario || ''}`, 10, y);
        y += 6;
        doc.text(`Depósito: ${i.vehiculo_deposito || ''} - Expedido en: ${i.vehiculo_expedido_en || ''}`, 10, y);
    });

    doc.save('infracciones.pdf');
}
